<template>
	<div>
		<div class="" style="position: relative;width:100%;height: 100%;">
			<div id="leftTop" style="width:100%;height:100%;"></div>
		</div>

	</div>
</template>

<script>
	import * as echarts from 'echarts'
	import 'echarts-gl'
	export default {
		data() {
			return {
				data: [],
				myChart: '',
				interVal:''
			}
		},
		mounted() {
			this.init({
				leftTitle:'总产值(亿元)',
				leftData:[480, 510, 520, 530, 550, 580, 610, 630],
				rightTitle:'同比增速(%)',
				rightData:[5.0,5.2,5.1,5.3,5.5,5.7,5.8,5.9],
				xData: ["2025年1月", "2025年2月", "2025年3月", "2025年4月", "2025年5月", "2025年6月", "2025年7月", "2025年8月"]
			})
		},
		methods: {
			setInitData(e){
				clearInterval(this.interVal)
				this.init(e)
				// {
				// 	leftTitle:'',
				// 	leftData:null,
				// 	rightTitle:'',
				// 	rightData:null,
				// 	xData:null
				// }
			},
			init(pageData) {
				let that = this
				// null 表示缺失月，不参与最大值计算
				const leftMax = Math.max.apply(null, (pageData.leftData || []).map(v => (v == null || isNaN(v)) ? 0 : v))
				this.myChart = echarts.init(document.getElementById("leftTop"), "purple-passion");
				//随着屏幕大小调节图表
				window.addEventListener("resize", () => {
					that.myChart.resize();
				});
				const offsetX = 10
				const offsetY = 5
				// 绘制左侧面
				const CubeLeft = echarts.graphic.extendShape({
					shape: {
						x: 0,
						y: 0
					},
					buildPath: function(ctx, shape) {
						// 会canvas的应该都能看得懂，shape是从custom传入的
						const xAxisPoint = shape.xAxisPoint
						// console.log(shape);
						const c0 = [shape.x, shape.y]
						const c1 = [shape.x - offsetX, shape.y - offsetY]
						const c2 = [xAxisPoint[0] - offsetX, xAxisPoint[1] - offsetY]
						const c3 = [xAxisPoint[0], xAxisPoint[1]]
						ctx.moveTo(c0[0], c0[1]).lineTo(c1[0], c1[1]).lineTo(c2[0], c2[1]).lineTo(c3[0], c3[1])
							.closePath()
					}
				})
				// 绘制右侧面
				const CubeRight = echarts.graphic.extendShape({
					shape: {
						x: 0,
						y: 0
					},
					buildPath: function(ctx, shape) {
						const xAxisPoint = shape.xAxisPoint
						const c1 = [shape.x, shape.y]
						const c2 = [xAxisPoint[0], xAxisPoint[1]]
						const c3 = [xAxisPoint[0] + offsetX, xAxisPoint[1] - offsetY]
						const c4 = [shape.x + offsetX, shape.y - offsetY]
						ctx.moveTo(c1[0], c1[1]).lineTo(c2[0], c2[1]).lineTo(c3[0], c3[1]).lineTo(c4[0], c4[1])
							.closePath()
					}
				})
				// 绘制顶面
				const CubeTop = echarts.graphic.extendShape({
					shape: {
						x: 0,
						y: 0
					},
					buildPath: function(ctx, shape) {
						const c1 = [shape.x, shape.y]
						const c2 = [shape.x + offsetX, shape.y - offsetY] // 右点
						const c3 = [shape.x, shape.y - offsetX]
						const c4 = [shape.x - offsetX, shape.y - offsetY]
						ctx.moveTo(c1[0], c1[1]).lineTo(c2[0], c2[1]).lineTo(c3[0], c3[1]).lineTo(c4[0], c4[1])
							.closePath()
					}
				})
				// 注册三个面图形
				echarts.graphic.registerShape('CubeLeft', CubeLeft)
				echarts.graphic.registerShape('CubeRight', CubeRight)
				echarts.graphic.registerShape('CubeTop', CubeTop)

				var option = {
					//你的代码
					legend: {
						show: true,
						right: 90,
						top: 10,
						itemGap: 30,
						itemWidth: 20,
						itemHeight: 10,
						data: [pageData.leftTitle, pageData.rightTitle],
						textStyle: {
							fontSize: 12,
							color: "#ffffff",
						},
					},
					color: ['#1A78E6', '#26D6D7', '#43EFFF'],
					tooltip: {
						trigger: 'axis',
						textStyle: {
							fontSize: 10 // 字体大小
						},
						axisPointer: {
							type: 'shadow'
						},
					},
					grid: {
						top: "25%",
						left: "3%",
						right: "5%",
						bottom: "5%",
						containLabel: true,
					},
					xAxis: {
						type: 'category',
						data: pageData.xData,
						axisLine: {
							show: true,
							lineStyle: {
								width: 1,
								color: 'rgba(239, 247, 253, .1)'
							}
						},
						axisTick: {
							show: false
						},
						axisLabel: {
							fontSize: 12,
							color: "#E7FCFF",
							margin: 20
						},
					},
					yAxis: [{
						type: 'value',
						name: pageData.leftTitle,
						nameGap: 30,
						nameTextStyle: {
							color: "#ffffff",
							fontWeight: 400,
							fontSize: 12,
						},
						axisLine: {
							show: true,
							lineStyle: {
								width: 1,
								color: 'rgba(239, 247, 253, .1)'
							}
						},
						splitLine: {
							show: true,
							lineStyle: {
								color: 'rgba(239, 247, 253, .1)',
							}
						},
						axisTick: {
							show: false
						},
						axisLabel: {
							fontSize: 12,
							color: "#E7FCFF"
						},
						min: 0,
						max: Math.ceil(leftMax / 5) * 5,
						interval: Math.ceil(leftMax / 5)
					}, {
						type: 'value',
						name: pageData.rightTitle,
						nameGap: 30,
						nameTextStyle: {
							color: "#ffffff",
							fontWeight: 400,
							fontSize: 12,
						},
						axisLine: {
							show: true,
							lineStyle: {
								width: 1,
								color: 'rgba(239, 247, 253, .1)'
							}
						},
						splitLine: {
							show: true,
							lineStyle: {
								color: 'rgba(239, 247, 253, .1)',
							}
						},
						axisTick: {
							show: false
						},
						axisLabel: {
							fontSize: 12,
							color: "#E7FCFF"
						},
					}],
					series: [{
						name: pageData.leftTitle,
						type: 'custom',
						renderItem: (params, api) => {
							// 缺失月(null)不绘制
							if (api.value(1) == null) return null
							const location = api.coord([api.value(0), api.value(1)])
							return {
								type: 'group',
								x: 0,
								children: [{
										type: 'CubeLeft',
										shape: {
											api,
											xValue: api.value(0),
											yValue: api.value(1),
											x: location[0],
											y: location[1],
											xAxisPoint: api.coord([api.value(0), 0])
										},
										style: {
											fill: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
													offset: 0,
													color: '#1A78E6'
												},
												{
													offset: 1,
													color: '#0F427C'
												}
											]),
											stroke: 'rgba(3, 25, 63, .1)', //边框颜色
										}
									},
									{
										type: 'CubeRight',
										shape: {
											api,
											xValue: api.value(0),
											yValue: api.value(1),
											x: location[0],
											y: location[1],
											xAxisPoint: api.coord([api.value(0), 0])
										},
										style: {
											fill: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
													offset: 0,
													color: '#1A78E6'
												},
												{
													offset: 1,
													color: '#0F427C'
												}
											]),
											stroke: 'rgba(3, 25, 63, .1)', //边框颜色
										}
									},
									{
										type: 'CubeTop',
										shape: {
											api,
											xValue: api.value(0),
											yValue: api.value(1),
											x: location[0],
											y: location[1],
											xAxisPoint: api.coord([api.value(0), 0])
										},
										style: {
											fill: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
													offset: 0,
													color: '#e6e6e6'
												},
												{
													offset: 1,
													color: '#ffffff'
												}
											]),
											stroke: 'rgba(3, 25, 63, .1)', //边框颜色
										}
									}
								]
							}
						},
						data: pageData.leftData
					}, {
						name: pageData.rightTitle,
						type: "line",
						showSymbol: true,
						smooth: true,
						symbol: 'circle',
						symbolSize: 10,
						yAxisIndex: 1,
						itemStyle: {
							color: "#01EEFD"
						},
						lineStyle: {
							width: 3,
						},
						areaStyle: {
							normal: {
								color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
										offset: 0,
										color: 'rgba(67, 239, 255, .3)',
									},
									{
										offset: 1,
										color: 'rgba(1, 17, 49, .3)',
									}
								]),
							},
						},
						data: pageData.rightData
					}]
				};

				this.myChart.setOption(option);

				this.interVal= setInterval(function() {
					that.myChart.clear()
					that.myChart.setOption(option);
				}, 15000)
			}
		}
	}
</script>

<style scoped>
	.sycw {
		font-size: 72rpx;
		font-family: DingTalk JinBuTi, DingTalk JinBuTi;
		font-weight: 900;
		color: #FFFFFF;
		text-shadow: 0px 8rpx 20rpx rgba(0, 0, 0, 0.8);
		-webkit-background-clip: text;
		-webkit-text-fill-color: #ffedf6;
	}

	.title {
		font-size: 24rpx;
		font-family: Source Han Sans, Source Han Sans;
		font-weight: 400;
		color: #dbecff;
		line-height: 40px;
		margin-left: 20rpx;
	}

	.bg {
		width: 30rpx;
		height: 30rpx;

	}
</style>